var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loadingImages)?_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(!_vm.loadingSubscription || Object.keys(_vm.currentImage).length > 0)?_c('OriginalImagesContent'):_vm._e()],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }